
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1CCr3", function(module, exports) {
$parcel$export(module.exports, "AddFeaturesSidebarSpotlight", () => (parcelRequire("asbHm")).AddFeaturesSidebarSpotlight);

var $asbHm = parcelRequire("asbHm");


});

parcelRegister("asbHm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");


var $inPa6 = parcelRequire("inPa6");


var $iXCQx = parcelRequire("iXCQx");


var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $8tIbq = parcelRequire("8tIbq");


var $lsxnT = parcelRequire("lsxnT");

/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages */ // Not a good idea to use experiment prefix in potentially long-lasting i18n strings

var $h82at = parcelRequire("h82at");

const $3b8a0fc692cee1ba$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    weAddedFeatures: {
        id: "creation-focused-nav.we-added-features",
        defaultMessage: "We added features to your sidebar"
    },
    toChangeYourView: {
        id: "creation-focused-nav.toChangeYourView",
        defaultMessage: "To change your view, customize your sidebar in the {menuName} menu"
    },
    more: {
        id: "creation-focused-nav.more",
        defaultMessage: "More"
    },
    customizeSidebar: {
        id: "creation-focused-nav.customizeSidebar",
        defaultMessage: "Customize sidebar"
    },
    gotIt: {
        id: "creation-focused-nav.gotIt",
        defaultMessage: "Got it"
    }
});



var $i4dNk = parcelRequire("i4dNk");

const $f373027e4dce4138$export$ea3b4f1126b4c509 = ({ isCollapsed: isCollapsed, children: children })=>{
    const { isSpotlightVisible: isSpotlightVisible, onSpotlightShown: onSpotlightShown } = (0, $i4dNk.useCfind4473CreationFocusedNav)();
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [hasDismissed, setHasDismissed] = (0, $42omo.useState)(false);
    const [shouldShowSpotlight, setShouldShowSpotlight] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (isSpotlightVisible) setShouldShowSpotlight(true);
    }, [
        isSpotlightVisible
    ]);
    const onDismiss = (reason)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissedCreationFocusedNavSpotlight',
                source: 'creation-focused-nav-button-spotlight',
                attributes: {
                    reason: reason
                }
            }
        }).fire();
        setHasDismissed(true);
    };
    const onShown = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'shown',
                actionSubject: 'spotlight',
                actionSubjectId: 'creationFocusedNavSpotlight',
                source: 'creation-focused-nav-button-spotlight'
            }
        }).fire();
        onSpotlightShown?.();
    };
    const isVisible = !isCollapsed && !hasDismissed && shouldShowSpotlight;
    if (!isVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8tIbq.UNSAFE_UpdateOnChange), {
        selectors: [
            'nav#side-navigation'
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopoverContent, {
        messageId: "creation-focused-nav-more-features-spotlight",
        messageType: "engagement",
        placement: "right-end",
        dismiss: ()=>onDismiss('auto'),
        isVisible: isVisible,
        onMessageDisposition: (status)=>{
            if (status === 'started') onShown();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
        testId: "spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $3b8a0fc692cee1ba$export$a7357cdd1f0b0168).weAddedFeatures)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), {
        onClick: ()=>onDismiss('dismiss-control')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        ...(0, $3b8a0fc692cee1ba$export$a7357cdd1f0b0168).toChangeYourView,
        values: {
            menuName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                as: "strong"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $3b8a0fc692cee1ba$export$a7357cdd1f0b0168).more))
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: ()=>onDismiss('primary-action')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $3b8a0fc692cee1ba$export$a7357cdd1f0b0168).gotIt)))))));
};
module.exports["AddFeaturesSidebarSpotlight"] = $f373027e4dce4138$export$ea3b4f1126b4c509;

});


//# sourceMappingURL=AddFeaturesSidebarSpotlight.e2dadf46.js.map
